import clsx from 'clsx';
import { Paragraph } from '@hungryroot/ui-kit';

import styles from './ProteinSourcingDisclosure.module.css';

export type ProteinSourcingVariant = 'seafood' | 'meat';

interface VariantConfig {
  testid: string;
  href: string;
  ariaLabel: string;
  copy: string;
}

const VARIANT_CONFIG: Record<ProteinSourcingVariant, VariantConfig> = {
  seafood: {
    testid: 'seafood-standards-disclosure',
    href: 'https://support.hungryroot.com/hc/en-us/articles/53434791576467-What-are-Hungryroot-s-seafood-sourcing-standards',
    ariaLabel: 'Learn more about our seafood sourcing standards',
    copy: '100% of our seafood is responsibly farmed or wild-caught. Learn more about our seafood sourcing standards',
  },
  meat: {
    testid: 'meat-standards-disclosure',
    href: 'https://support.hungryroot.com/hc/en-us/articles/54310611621651-What-are-Hungryroot-s-meat-sourcing-standards',
    ariaLabel: 'Learn more about our meat sourcing standards',
    copy: 'Our meat is thoughtfully sourced from trusted suppliers committed to quality, animal care, and transparency. Learn more about our meat sourcing standards',
  },
};

interface Props {
  variant: ProteinSourcingVariant;
  className?: string;
}

/**
 * Standards disclosure shown on seafood and meat product detail pages,
 * placed directly under the product description.
 */
export function ProteinSourcingDisclosure({ variant, className }: Props) {
  const { testid, href, ariaLabel, copy } = VARIANT_CONFIG[variant];

  return (
    <Paragraph className={clsx(styles.disclosure, className)} testid={testid}>
      {copy}{' '}
      <a
        className={styles.link}
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={ariaLabel}
      >
        here
      </a>
      .
    </Paragraph>
  );
}
